import { Injectable } from "@angular/core";
import { WebApiUrlBuilderService } from "./web-api-url-builder.service";
import { OpengroundCloudHttpClient } from "../http/openground-cloud-http-client.service";
import { WebApiConfigurationService } from "../configuration/web-api/web-api-configuration.service";

@Injectable({
  providedIn: "root",
})
export class WebApiService {
  constructor(
    private urlBuilderService: WebApiUrlBuilderService,
    private http: OpengroundCloudHttpClient,
    private configurationService: WebApiConfigurationService,
  ) {}

  post<T>(resourcePath, body, options?) {
    options = {
      ...options,
      body: body
    };
    return this.request<T>('post', resourcePath, options);
  }

  put<T>(resourcePath, body, options?) {
    options = {
      ...options,
      body: body
    };
    return this.request<T>('put', resourcePath, options);
  }

  get<T>(resourcePath, options?) {
    return this.request<T>('get', resourcePath, options);
  }

  delete<T>(resourcePath, options?) {
    return this.request<T>('delete', resourcePath, options);
  }

  request<T>(method, resourcePath, options?) {
    if (!options) {
      options = {};
    }
    const resourceUrl = this.createResourceUrl(resourcePath, options.useDefaultConfiguration);
    return this.http.request<T>(
      method,
      resourceUrl,
      this.createOptions(options)
    );
  }

  getConfiguration(useDefaultConfiguration = false) {
    if (useDefaultConfiguration) {
      return this.getDefaultConfiguration();
    } else {
      return this.getLocalConfiguration();
    }
  }

  getDefaultConfiguration() {
    return this.configurationService.getDefaultConfiguration();
  }

  getLocalConfiguration() {
    return this.configurationService.getLocalConfiguration();
  }

  createResourceUrl(resourcePath, useDefaultConfiguration?) {
    return this.urlBuilderService.createResourceUrl(this.getConfiguration(useDefaultConfiguration), resourcePath);
  }

  createOptions(options?, useDefaultConfiguration?) {
    const configuration = this.getConfiguration(useDefaultConfiguration);
    return {
      addInstanceIdHeader: configuration.addInstanceIdHeader,
      ...options
    };
  }
}
